import React, { useEffect, useState } from 'react';
import './modalChurned.css';
import { Search } from '../search/search.js';
import { Input } from '../input/input.js';
import { ReactComponent as X } from './x.svg';
import { Button } from '../button/button';

function ModalChurned(props) {
    const [initialData, setInitialData] = useState([])
    const [data, setData] = useState([])
    const [selected, setSelected] = useState([])

    useEffect(() => {
        setInitialData(props.racks)
        setData(props.racks)
        setSelected(props.base)
    }, [props.racks])

    function Checked(itens, isChecked) {
        if (isChecked) {
            setSelected([...selected, { ...itens, reserved: props.reserved }]);
        } else {
            setSelected(selected.filter(item => item.id !== itens.id));
        }
    }


    return (
        <section className='modal-churned'>
            <div className='modal-churned-view-count'>
                <div className='title-churned'>
                    <X className='x-churned' onClick={() => props.setOpen(false)} />
                    <h1>Select Racks</h1>
                </div>
                <div className='body-racks1'>
                    <Search style={{ width: '100%' }} initialData={initialData}
                        set={setData}
                        placeholder="Search Rack" />
                    <div className='body-racks-modalChurned'>
                        {
                            data.length > 0 ?
                                data.map((rack, i) => {
                                    return (
                                        <div key={rack.id} className='body-content-rack-card-modal'>
                                            <Input type='checkbox' checked={selected.some(el => el.id === rack.id)} name='rack1' value='rack1' onChange={(e) => Checked(rack, !selected.some(el => el.id === rack.id))} />
                                            <div className='content-rack-card-modal'>
                                                {rack.reserved && <div>
                                                    <h3 style={{ backgroundColor: '#E89F1770', width: '100%', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>Reserved</h3>
                                                </div>}
                                                <div>
                                                    <h3 style={{ backgroundColor: '#BDBDBD', borderTopLeftRadius: rack.reserved ? 0 :8 }}>N {rack.nrack}</h3>
                                                    <h3 style={{ backgroundColor: '#BDBDBD', borderTopRightRadius: rack.reserved ? 0 : 8 }}>N Scala {rack.nscala}</h3>
                                                </div>
                                                {
                                                    rack.pduRacks.map(pdu => (
                                                        <div>
                                                            <h3 style={{ backgroundColor: '#00838D33' }}>{pdu.name}</h3>
                                                            <h3 style={{ backgroundColor: '#00838D33' }}>{pdu.circuito}</h3>
                                                        </div>
                                                    ))
                                                }
                                                <div>
                                                    <h3 style={{ backgroundColor: '#EDEDED' }}>{rack.fileira ? 'Fileira ' + rack.fileira : 'N/A'}</h3>
                                                    <h3 style={{ backgroundColor: '#EDEDED' }}>{rack.posicao ? 'Posição ' + rack.posicao : 'N/A'}</h3>
                                                </div>
                                                <div>
                                                    <h3 style={{ backgroundColor: '#EDEDED', borderBottomLeftRadius: 8 }}>{'Potência ' + rack.potenciaContratada ? rack.potenciaContratada : 'N/A'}</h3>
                                                    <h3 style={{ backgroundColor: '#EDEDED', borderBottomRightRadius: 8 }}>{'Ocupação ' + rack.ocupacao ? rack.ocupacao : 'N/A'}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                :
                                <h3 style={{ fontWeight: 600 }}>No {props.type[0]} racks were found for {props.type[1]}.</h3>
                        }
                    </div>
                </div>
                <div className='btns-modal-churned'>
                    <Button
                        onClick={() => {
                            props.setOpen(false)
                        }}
                        style={{ width: '48%', marginRight: '5px' }}
                        label={"Cancel"}
                    />
                    <Button onClick={() => {
                        selected.length !== props.base.length && props.churned(selected)
                        props.setOpen(false);
                        setSelected([])
                    }}
                        style={{ width: '48%', background: "#0F0742", color: "#fff", marginLeft: '5px' }}
                        label={"Confirm"} />
                </div>

            </div>
        </section>
    );
}

export default ModalChurned;
